import { useState } from 'react'
import '../styles/Coberturas.css'
import CoberturasCards from './CoberturasCards'
import ModalActivarCuenta from './modal/ModalActivarCuenta'

const Coberturas = ({coberturas, coberturasDesc}) => {

    const [mostrarModalActivarCuenta, setMostrarModalActivarCuenta] = useState(false)
    
    return (
        <>
            <ModalActivarCuenta
                show={mostrarModalActivarCuenta}
                close={setMostrarModalActivarCuenta}
            /> 
            <div id='coberturas' style={{'scrollMarginTop':'80px'}} className=' mw-1000'>
                <div className="homeout__coberturas container mt-5">
                    <h2 className='color_azul mb-4'>¿Cómo funciona tu seguro?</h2>
                    <p className='text-center'>Descubre cómo te protegemos, haz clic en “Conoce más” para más detalles</p> 
                    <CoberturasCards coberturas={coberturas} coberturasDesc={coberturasDesc} /> 
                </div> 
            </div>
        </>
    )
}

export default Coberturas